module.exports = __webpack_public_path__ + "img/HZGB02-01-04.7afe694.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/HZGB02-01-04.png
// module id = NDg+
// module chunks = 0